

export default {
  install(Vue) {
    Vue.prototype.$pluginReport = {
      async init() {
        // 插入上报库的js文件
      },
      async click(params) {
        console.log('tgclub report.click, params=', params);
      },
      async expose(params) {
        console.log('tgclub report.expose, params=', params);
      },
      async module(params) {
        console.log('tgclub report.module, params=', params);
      },
      // 除了click、expose、module 3个必需的方法，还可以定义更多方法供手动调用
    };
  },
};
